import png from './mmc.png'
import png2x from './mmc@2x.png'
import webp from './mmc.webp'
import webp2x from './mmc@2x.webp'

const index = {
  png,
  png2x,
  webp,
  webp2x,
}

export default index
